import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, input, Input, Output } from "@angular/core";

@Component({
	selector: "pv-article-component",
	templateUrl: "./article.component.html",
	styleUrls: ["./article.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ArticleComponent {
	@Input() title: string;
	@Output() state = new EventEmitter();
	@Input() open = true;
	@Input() color: string;

	readonly dataHeaderClass = input<string>();

	@HostBinding("class.locked") @Input() locked = false;

	toggle() {
		if (this.locked) {
			return;
		}

		this.open = !this.open;
		this.state.emit(this.open);
	}
}
